<!--
 * @Description: 
 * @Autor: lwq
 * @Date: 2020-08-13 11:01:51
 * @LastEditors: lwq
 * @LastEditTime: 2020-08-13 11:12:04
 * @FilePath: \mrc-base-server-view\src\components\mrc_ess_showClientType.vue
-->
<template>
  <div>
    <mrc_ess_svgIcon v-for="item in svgList"
                     :key='item'
                     :icon-class='item'></mrc_ess_svgIcon>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  components: {},
  props: {
    iconList: {
      type: [String, Array]
    }
  },
  data () {
    return {

    };
  },
  validations: {},
  computed: {
    svgList () {
      const type = Object.prototype.toString.call(this.iconList)
      if (type.indexOf('array') > -1) {
        return this.iconList
      } else if (type.indexOf('string') > -1) {
        const arr = this.iconList.split(',')
        return arr
      } else {
        return []
      }
    }
  },
  created () { },
  watch: {},
  mounted () { },

  methods: {

  },
};
</script>

<style scoped>
</style>
